import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cmNineDocName'
})
export class DocumentNamePipe implements PipeTransform {

  transform(value: any, gpn: string): string {
      if(gpn && gpn.length> 0){
        let docN = value && value.indexOf("GPN_") > -1 ? value.replace("GPN_", `${gpn}_`) : `${gpn}_${value}`;
          return docN
      } else {
        return value.replace("GPN_", '');
      }
  }

}
